import React from 'react';
import './Watermark.scss';

const Watermark = ({ children, text, textColor, fontSize, opacity, isPreviewMain }) => {
  return (
    <div className={`watermark-container ${isPreviewMain ? 'preview-main' : ''}`}>
      {children}
      <div 
        className="watermark-overlay"
        style={{
          color: textColor,
          fontSize: fontSize,
          opacity: opacity
        }}
      >
        {Array.from({ length: 9 }).map((_, rowIndex) => (
          <div key={rowIndex} className="watermark-text">
            {Array.from({ length: 20 }).map((_, colIndex) => (
              <span key={colIndex}>{text}</span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Watermark;